<div class="team-utilization">
  <div class="utilization-chart">
    <h4>Team Utilization</h4>
    <div class="chart">
      <div class="content">
        <label>Total<br />Team Utilization</label>
        <strong>{{teamUtilization}}%</strong>
      </div>
      <app-donut-chart
        *ngIf="headCount"
        [donutChartData]="talentChartData"
        [name]="'talent'"
        [width]="chartWidth"
        [height]="chartHeight"
      ></app-donut-chart>
    </div>
  </div>
  <div class="talent-tab-wrapper">
    <div class="tabs">
      <span
        *ngFor="let tab of tabs"
        class="{{ tab.active ? 'active' : '' }}"
        (click)="tabClickHandler(tab)"
        >{{ tab.label }}</span
      >
    </div>
    <div *ngIf="currentActiveTab === 'division'">
      <app-multi-color-progress-bar
        [title]="'Head Count'"
        [headCount]="headCount"
      ></app-multi-color-progress-bar>
      <app-multi-color-progress-bar
        [title]="'Diversity'"
        *ngIf="diversity"
        [data]="diversity"
      ></app-multi-color-progress-bar>
      <app-multi-color-progress-bar
        [title]="'Pyramid Mix'"
        *ngIf="pyramids"
        [data]="pyramids"
        [tootip]="true"
      ></app-multi-color-progress-bar>
      <app-multi-color-progress-bar
        [title]="'Location'"
        *ngIf="location"
        [data]="location"
        [tootip]="true"
      ></app-multi-color-progress-bar>
    </div>
    <div *ngIf="currentActiveTab === 'promotionProgression'">
      <app-promotion-progression></app-promotion-progression>      
    </div>
    <div *ngIf="currentActiveTab === 'hiringAttrition'">
      <app-hiring-attrition></app-hiring-attrition>
    </div>
    <div *ngIf="currentActiveTab === 'trainingCertification'">
      <app-training-certification></app-training-certification>
    </div>
  </div>
</div>
